import React from "react";
import SectionHeading from "./SectionHeading";
import {
  Brain,
  Eye,
  MessageSquare,
  Zap,
  TrendingUp,
  Bot,
} from "lucide-react";

const services = [
  {
    icon: Brain,
    title: "Machine Learning",
    description:
      "Custom ML pipelines including classification, recommendation engines, anomaly detection, feature engineering, model optimization, and deployment pipelines.",
  },
  {
    icon: Eye,
    title: "Computer Vision",
    description:
      "Real-time object detection, image segmentation, OCR, facial recognition, defect detection, quality inspection, and visual intelligence.",
  },
  {
    icon: MessageSquare,
    title: "Natural Language Processing",
    description:
      "Conversational AI, multilingual chatbots, document intelligence, sentiment analysis, semantic search and custom LLM applications.",
  },
  {
    icon: Zap,
    title: "Intelligent Automation",
    description:
      "Workflow automation powered by AI decision making, document processing, invoice automation, and intelligent workflow optimization.",
  },
  {
    icon: TrendingUp,
    title: "Predictive Analytics",
    description:
      "Forecast sales, predict churn, optimize inventory, customer lifetime value prediction, and real-time business intelligence dashboards.",
  },
  {
    icon: Bot,
    title: "Generative AI Integration",
    description:
      "ChatGPT, Claude, Gemini, custom LLMs, RAG pipelines, AI assistants, document chat, knowledge bases, and enterprise copilots.",
  },
];

export default function AIServices() {
  return (
    <section className="bg-[#F8F8FB] py-20 border-t border-gray-200/60">
      <div className="max-w-7xl mx-auto px-6">
        {/* Heading */}
        <div className="max-w-3xl mx-auto">
          <SectionHeading
            eyebrow="AI Solutions"
            title="AI Services That Scale"
            description="Every service is engineered for production—not demos. We build AI that earns measurable ROI."
            theme="light"
            titleClassName="text-[#111827]"
            descriptionClassName="text-base leading-7"
          />
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mt-16">
          {services.map((service, index) => {
            const Icon = service.icon;
            return (
              <div
                key={index}
                className="group bg-white rounded-2xl border border-gray-200 p-8 transition-all duration-300 hover:-translate-y-2 hover:shadow-xl hover:border-[#355dff]"
              >
                <div className="w-12 h-12 rounded-xl bg-[#EBF2FF] flex items-center justify-center group-hover:bg-[#355dff] transition-all duration-300 mb-6">
                  <Icon
                    size={24}
                    className="text-[#355dff] group-hover:text-white transition-all"
                  />
                </div>
                <h3 className="text-xl font-bold text-[#111827] mb-3">
                  {service.title}
                </h3>
                <p className="text-gray-500 leading-7 text-[14px]">
                  {service.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}